import React from 'react'
import { useDispatch } from 'react-redux'
import { HeaderStyled } from './FavouriteNumbers.styles'
import { HeaderWithLoadingIndicator } from './HeaderWithLoader'
import { clearSelections } from './Store'
import { FavouriteNumbersBetSummary } from './FavouriteNumbersBetSummary'
import { NumberSelection } from './NumberSelection'
import { PoolSelection } from './PoolSelection'

export const EasyBetTab = (): JSX.Element => {
  const dispatch = useDispatch()

  React.useEffect(() => {
    return () => {
      dispatch(clearSelections())
    }
  }, [dispatch])

  return (
    <div data-testid='easy-bet' style={{ marginTop: '1em' }}>
      <HeaderWithLoadingIndicator title={'SELECT NUMBERS'}></HeaderWithLoadingIndicator>
      <NumberSelection />
      <HeaderStyled>SELECT POOL DATES</HeaderStyled>
      <PoolSelection />
      <HeaderStyled>BET SUMMARY</HeaderStyled>
      <FavouriteNumbersBetSummary mode={'easyBet'} />
    </div>
  )
}
